import { createContext, useContext, useState } from "react";
import { OriginalData } from "../../Models/OriginalData";
import { OriginalHeadCount } from "../../Models/OriginalHeadCount";

interface DataProviderProps {
  children: React.ReactNode;
}

type DataContextType = {
  data: { headCount: OriginalHeadCount[]; value: OriginalData[] };
  setData: (data: {
    headCount: OriginalHeadCount[];
    value: OriginalData[];
  }) => void;
  originalData: { headCount: OriginalHeadCount[]; value: OriginalData[] };
  setOriginalData: (data: {
    headCount: OriginalHeadCount[];
    value: OriginalData[];
  }) => void;
};

export const DataContext = createContext<DataContextType>({
  data: { headCount: [], value: [] },
  setData: () => {},
  originalData: { headCount: [], value: [] },
  setOriginalData: () => {},
});

const DataProvider = (props: DataProviderProps) => {
  const [data, setData] = useState<{
    headCount: OriginalHeadCount[];
    value: OriginalData[];
  }>({
    value: [],
    headCount: [],
  });
  const [originalData, setOriginalData] = useState<{
    headCount: OriginalHeadCount[];
    value: OriginalData[];
  }>({ value: [], headCount: [] });

  return (
    <DataContext.Provider
      value={{ data, setData, originalData, setOriginalData }}
    >
      {props.children}
    </DataContext.Provider>
  );
};

export default DataProvider;

export const useData = () => {
  const { data, setData, originalData, setOriginalData } =
    useContext(DataContext);
  return { data, setData, originalData, setOriginalData };
};
